module.exports = __webpack_public_path__ + "img/dollar-green.42ca49ca.png";